<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <!-- <search-field ref="searchRef" @search="search"></search-field> -->
            <v-spacer></v-spacer>
            <add-button @add="openAddDialog"></add-button>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="refreshData()"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Refresh</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel</span>
            </v-tooltip>
            <!-- Dialog for Add, View Edit  -->
            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <module-container
                v-if="dialogType === 'module'"
                :page_id="viewData.id"
              ></module-container>

              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md6>
                    <!-- Insert View Dialog Content BELOW-->
                    <details-container
                      v-if="dialogType !== 'module'"
                      ref="detailsRef"
                      :data="viewData"
                      :readonly="dialogType === 'view'"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
                dialogType === 'edit'
                  ? saveEditDialog()
                  : dialogType === 'add'
                  ? saveAddDialog()
                  : dialogType === 'multiple'
                  ? saveMultiAssignDialog()
                  : dialogType === 'settings'
                  ? saveSettingsDialog()
                  : ''
              "
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>

            <message-dialog
              :dialog="messageDialog"
              :title="messageTitle"
              :message="messageText"
              @save="dialogType === 'remove' ? saveRemoveDialog() : ''"
              @close="closeMessageDialog"
              :loading="messageLoading"
            ></message-dialog>
          </v-card-title>

          <v-divider></v-divider>

          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.version }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.purchase_amount
                    ? $amountInPeso(props.item.purchase_amount)
                    : "--"
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.credit_amount
                    ? $amountInPeso(props.item.credit_amount)
                    : "--"
                }}
              </td>
              <td class="text-xs-center">{{ props.item.claim_duration }}</td>
              <td class="text-xs-center">
                {{
                  props.item.createdAt
                    ? $dateFormat(props.item.createdAt,"YYYY-MM-DD")
                    : "--"
                }}
              </td>
              <td class="text-no-wrap text-xs-center">
                <delete-button
                  @delete="openRemoveDialog(props.item.version)"
                ></delete-button>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/VersionDetailsContainer.vue";
var now = new Date();
import XLSX from "xlsx";

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      dialogue: false,
      cancelDialog: false,
      confirmLoading: false,
      dialogLoading: false,
      items: [],
      title: "Credit Sold Version",
      headers: [
        { text: "#", align: "left", sortable: false },
        {
          text: "Version",
          align: "center",
          value: "version",
          sortable: false,
        },
        {
          text: "Purchase Amount",
          align: "center",
          value: "purchase amount",
          sortable: false,
        },
        {
          text: "Credit Amount",
          align: "center",
          value: "credit amount",
          sortable: false,
        },
        {
          text: "Claim Duration",
          align: "center",
          value: "date_start",
          sortable: false,
        },
        {
          text: "Date Created",
          align: "center",
          value: "date_created",
          sortable: true,
        },
        {
          text: "Action",
          align: "center",
          value: "action",
          sortable: true,
        },
      ],
      data: {},
      viewData: {
        purchase_amount: 40,
        credit_amount: 60,
      },
      queryParams: {
        search: null,
        limit: 10,
        offset: 0,
      },
      dialogLoading: false,
      dialogType: "",
      dialogTitle: "",
      dialogStatus: false,
      openConfirmDialog: false,
      confirmLoading: false,
      messageDialog: false,
      messageTitle: "",
      messageText: "",
      messageLoading: false,
      valid: true,
      dateFromMenu: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateToMenu: false,
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: 60, value: 60 },
        { text: 70, value: 70 },
        { text: 80, value: 80 },
        { text: 90, value: 90 },
        { text: 100, value: 100 },
      ],
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      disabledLimit: true,
      uploadLoading: false,
      valid: true,
      totalItems: 0,
    };
  },
  created: async function() {
    await this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  watch: {},
  methods: {
    async getData() {
      // Start Loading
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getSoldVersion(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }

        if (this.totalItems <= this.queryParams.limit) {
          this.disabledLimit = true;
        } else {
          this.disabledLimit = false;
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }
      this.$store.dispatch("endLoading");
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.dialogStatus = true;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async saveAddDialog() {
      this.confirmLoading = true;
      const data = this.$refs.detailsRef.computedData,
        body = {
          user_id: data.user_id,
          version: data.version,
          purchase_amount: data.purchase_amount,
          credit_amount: data.credit_amount,
          claim_duration: data.claim_duration,
        };
      try {
        const response = await Services.addVersion(body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Version has been added!",
          });
          this.viewData = {
            version: data,
          };
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            this.closeDialog();

            this.$store.dispatch("dispatchUnauthorized", true);
          } else if (error.response.status === 422) {
            this.$infoBar({
              type: "error",
              text: `${this.$capitalizeFirstLetter(
                error.response.data.message
              )} `,
            });
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          }
        }
      }
      this.confirmLoading = await false;
    },
    async openRemoveDialog(data) {
      this.messageDialog = true;
      this.messageTitle = "Remove " + this.title;
      this.messageText = `Are you sure you want to Remove this ${this.title}?`;
      this.dialogType = "remove";

      this.viewData = {
        version: data,
      };
    },
    async saveRemoveDialog() {
      this.messageLoading = true;
      try {
        const response = await Services.deleteVersion(this.viewData.version);

        if (response.status === 200 || response.status === 201) {
          this.closeMessageDialog();

          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Version has been removed!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.messageLoading = false;
    },
    async closeMessageDialog() {
      this.messageDialog = false;
      this.viewData = {};
    },
    closeDialog() {
      this.viewData = {};

      this.closeConfirmDialog();
      this.dialogTitle = "";
      this.dialogType = "";
      this.dialogStatus = false;
    },
    openMultiDeleteDialog() {
      this.deleteDialog = true;
      this.deleteType = "multiple";
      this.deleteTitle =
        "Are you sure you want to Delete this " + this.title + "s";
    },
    saveDialog() {
      // Condition Form Required Form Validation
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
      }
      this.openConfirmDialog = true;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    refreshData() {
      this.getData();
    },
    async downloadExcel() {
      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length - 1; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();

      dataToDownload.push(header);

      for (let e = 0; e < this.items.length; e++) {

        const theItem = [];

        theItem.push(this.items[e].version ? this.items[e].version.toUpperCase() : "--");
        theItem.push(this.items[e].purchase_amount ? this.items[e].purchase_amount : 0);
        theItem.push(this.items[e].credit_amount ? this.items[e].credit_amount : 0);
        theItem.push(this.items[e].claim_duration ? this.items[e].claim_duration : "--");
        theItem.push(this.$dateFormat(this.items[e].createdAt, "YYYY-MM-DD"));

        dataToDownload.push(theItem);
      };

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
        { wch: 30 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>

<style scoped></style>
